<script>

    import { FixedpriceStore } from '../stores'
    
    import Modal from '../$components/modal.svelte'
    import Fixedprices from '../fixedprices/fixedprices.svelte'
    import FixedpriceRead from '../fixedprices/fixedprice.svelte'

</script>

<Fixedprices />
 
<Modal id="FixedpriceRead" title="Información precio fijo" >
    <FixedpriceRead on:deleted={FixedpriceStore.modalClose} />
</Modal>